module.exports = __webpack_public_path__ + "media/images/logo/product-self-7442a8fea3863cfaf637f684ce7f44f1.png";